module.exports = __webpack_public_path__ + "img/3.f28ef145.png";